import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from '../../../core/service/base/data.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { PriceList } from '../../model/pricelist';
import { PriceListItem } from '../../model/pricelistitem';

@Injectable()
export class PriceListItemService extends DataService<PriceListItem> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, PriceListItem, progressBar, 'price-list-item');
  }

  protected createModel(context: any): PriceListItem {
    return new PriceListItem(context);
  }
}
